import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../Buttons/ButtonBase';
import CardBenefits from './CardBenefits';
import './WebinarCellphone.scss';

const useStyles = makeStyles({
    container: {
        justifyContent: 'center',
        width: '100%',
    },
    buttonStyle: {
        margin: '74px 0 0',
        minWidth: 293,
    }
})

const WebinarCellphone = () => {

    const handleScroll = () => {
        console.log('scroll arriba');
    }

    const classes = useStyles()

    const data = [
        {
            number: '82',
            title: 'millones',
            text: 'de mexicanos tienen acceso a internet',
            id: 1,
        },
        {
            number: '70%',
            title: 'de incremento',
            text: 'el uso de internet aumentó en México durante la pandemia',
            id: 2
        },
        {
            number: '66%',
            title: 'de las personas',
            text: 'que buscan en internet algún servicio o producto terminan adquiriéndolo en la misma página donde lo encontraron',
            id: 3
        },
    ]

    return (
        <div className='WebinarCellphone'>
            <div className='WebinarCellphone_container'>
                <div className='WebinarCellphone_imageContainer'>
                    <img
                        className='WebinarCellphone_imageContainer-img'
                        src='/img/Webinar/Cellphone/hand.png'
                        alt='cel'
                    />
                </div>
                <div className='WebinarCellphone_infoContainer'>
                    <p className='WebinarCellphone_infoContainer-title'>
                        ¿Sabía usted que <strong>será invisible</strong> para los usuarios
                        en línea y no aparecerá en
                        estas <strong>búsquedas</strong> sino <strong>construye un
                        posicionamiento</strong> en internet?
                    </p>
                    <Grid
                        container
                        spacing={2}
                        classes={{ container: classes.container }}
                    >
                        {data && data.map(elem => (
                            <Grid key={elem.id} item>
                                <CardBenefits data={elem} />
                            </Grid>
                        ))}
                    </Grid>
                    <div className='WebinarCellphone_infoContainer-button'>
                        <LinkScroll to="webinarForm" smooth="true" duration={500} offset={-60}>
                            <ButtonBase
                                type="submit"
                                onClick={handleScroll}
                                variant="secondary"
                                linkStyle={classes.linkStyle}
                                buttonStyle={classes.buttonStyle}
                            >
                                Quiero asistir al webinar
                            </ButtonBase>
                        </LinkScroll>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WebinarCellphone;
